import { SharedPhoto } from '../types/SharedCollection';

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)(\?|#|$)/i;

export function isSharedVideoPhoto(photo: SharedPhoto): boolean {
   if (photo.mediaType === 'video') return true;
   if (photo.mediaType === 'photo') return false;
   return Boolean(photo.videoUrl);
}

/** URL used in `<video src>` for full playback (lightbox). */
export function videoPlaybackSrc(photo: SharedPhoto): string {
   return photo.videoUrl || photo.url;
}

export function countVideosInPhotos(photos: SharedPhoto[]): number {
   return photos.filter((p) => isSharedVideoPhoto(p)).length;
}

/** True when thumbnailUrl is a real image poster, not the same as the video file. */
export function hasVideoImagePoster(photo: SharedPhoto): boolean {
   if (!isSharedVideoPhoto(photo)) return false;
   const thumb = photo.thumbnailUrl;
   const vid = photo.videoUrl || photo.url;
   if (!thumb || !vid) return false;
   if (thumb === vid) return false;
   return IMAGE_EXT.test(thumb);
}
